export default "__VITE_ASSET__cdcd7895__"